import script from './SdsSidebarButton.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sds-sidebar-button sds-focus",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"sds-sidebar-button__label"},[_vm._v(_vm._s(_vm.label))])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-1f427b50_0", { source: ".sds-sidebar-button[data-v-1f427b50]{display:flex;justify-content:space-between;align-items:center;min-height:40px;padding:8px 12px 8px 40px;background-color:transparent;border:none;border-radius:var(--radius-full);font-family:var(--system-label-default-family),sans-serif;font-size:var(--system-label-default-size);font-weight:600;line-height:var(--system-label-default-line-height);letter-spacing:var(--system-label-default-letter-spacing);text-transform:capitalize;color:var(--system-text-on-elevation-secondary);cursor:pointer}.sds-sidebar-button[data-v-1f427b50]:hover{background:var(--gradients-component-sidebar-inactive-hover)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-1f427b50";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
